"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.onChangeDateTimeField = exports.mapDateTimeFieldProperties = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _dateFns = require("date-fns");

var _react = _interopRequireDefault(require("react"));

var _reactLoadable = _interopRequireDefault(require("react-loadable"));

var _Loader = _interopRequireDefault(require("../../Loader"));

var _DateHelper = require("../../Utilities/DateHelper");

var _Validations = require("../../Validations");

var _FieldMapper = _interopRequireWildcard3(require("./FieldMapper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LoadableDatePicker = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../DateTimePicker"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});

var getValidations = function getValidations(field) {
  var validations = [];
  validations.push(_Validations.validDateValidation);

  if (field.properties.isRequired) {
    validations.push(_Validations.requiredValidation);
  }

  if (field.properties.maxValue) {
    validations.push(_Validations.maxValueDateValidation);
  }

  if (field.properties.minValue) {
    validations.push(_Validations.minValueDateValidation);
  }

  return validations;
};

var getDerivedValue = function getDerivedValue(field, value) {
  var derivedValue = value;

  if (!value) {
    if (!field.properties.isRequired) {
      if (field.properties.calculatedDefaultValue) {
        derivedValue = field.properties.calculatedDefaultValue === "Today" ? (0, _dateFns.startOfDay)(new Date()) : new Date();
      } else if (field.properties.defaultValue) {
        derivedValue = new Date(field.properties.defaultValue);
      }
    }
  }

  return derivedValue;
};

var mapInputProperties = function mapInputProperties(field, model, value) {
  var minDate, maxDate;
  minDate = new Date(field.properties.minValue);
  maxDate = new Date(field.properties.maxValue);

  if ((0, _dateFns.isValid)(maxDate) && field.properties.editor === "Date") {
    maxDate = (0, _dateFns.endOfDay)(maxDate);
  }

  minDate = (0, _dateFns.isValid)(minDate) ? minDate : undefined;
  maxDate = (0, _dateFns.isValid)(maxDate) ? maxDate : undefined;
  return _objectSpread(_objectSpread({}, model), {}, {
    component: LoadableDatePicker,
    minValue: minDate,
    maxValue: maxDate,
    validations: getValidations(field),
    doNotValidate: true,
    onChange: onChangeDateTimeField,
    keyboard: field.properties.editor !== "Time",
    pickerType: field.properties.editor === "Time" ? "time" : field.properties.editor === "DateTime" ? "dateTime" : "date",
    format: field.properties.editor === "Time" ? "hh:mm aa" : field.properties.editor === "DateTime" ? "M/d/yyyy h:mm aa" : "M/d/yyyy",
    value: getDerivedValue(field, value)
  });
};

var mapDateTimeFieldProperties = function mapDateTimeFieldProperties(_ref) {
  var field = _ref.field,
      htmlId = _ref.htmlId,
      value = _ref.value,
      onValidation = _ref.onValidation;
  var model = (0, _FieldMapper.default)(field, htmlId, value, undefined, onValidation);
  return mapInputProperties(field, model, value);
};

exports.mapDateTimeFieldProperties = mapDateTimeFieldProperties;

var onChangeDateTimeField = function onChangeDateTimeField(params) {
  // const event = params[0];
  var value = params[1];
  var date = {
    display: "",
    value: ""
  };
  date.display = value;

  if (value) {
    date.value = (0, _DateHelper.convertDateTimeValueToUtc)(value);
  }

  return date;
};

exports.onChangeDateTimeField = onChangeDateTimeField;
var _default = mapDateTimeFieldProperties;
exports.default = _default;